import translation from 'src/config/fw-ai/dougal-gpt.json'
const TranslationService = () => ({
  async fetchTranslation() {
    return translation.resources
  }
})

export default TranslationService
